<div class="modal show" style="display: block;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title text-start" id="modalTitle" i18n>Crop file</h3>
      </div>
      <div class="modal-body">
        <image-cropper
          [imageChangedEvent]="injectedData.imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="4 / 4"
          [resizeToWidth]="256"
          format="png"
          (imageCropped)="imageCropped($event)"
        >

        </image-cropper>
      </div>
      <div class="modal-footer">
        <button mat-dialog-close type="button" class="button_tertiary_outline btn btn-light">Закрити</button>
        <button [mat-dialog-close]="imageFile" type="button" class="button btn btn-primary">Зберегти зміни</button>
      </div>
    </div>
  </div>
</div>
